import React from 'react'
import Link from 'gatsby-link'

import styles from './header.module.css'

import sand from '../images/sand.png'
import grass from '../images/grass.png'
import chrisSprite from '../images/chris-sprite.png'
import hamburger from '../images/hamburger.svg'

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {mobileMenuActive: false};
  }

  mobileNavClickHandler = () => {
    this.setState({
      mobileMenuActive: !this.state.mobileMenuActive,
    });
  }

  render() {
    const {siteTitle} = this.props;

    return (
      <div
        className={styles.header}
      >
        <img 
          className={styles.hamburgerIcon}
          src={hamburger}
          onClick={this.mobileNavClickHandler}
        />
        <nav
          className={styles.nav}
        >
          {/* desktop nav */}
          <ul
            className={styles.navList}
          >
            <li><Link to="/">home</Link></li>
            <li><Link to="/about/">about</Link></li>
            <li><Link to="/work/">work</Link></li>
            <li><Link to="/resume/">resume</Link></li>
            <li><a href="https://linkedin.com/in/topherdeaton">linkedin</a></li>
            <li><Link to="/contact/">contact</Link></li>
          </ul>

          {/* mobile nav */}
          <ul
            className={this.state.mobileMenuActive ? styles.mobileMenuActive: styles.mobileMenuInactive}
          >
            <li><Link to="/">home</Link></li>
            <li><Link to="/about/">about</Link></li>
            <li><Link to="/work/">work</Link></li>
            <li><Link to="/resume/">resume</Link></li>
            <li><a href="https://linkedin.com/in/topherdeaton">linkedin</a></li>
            <li><Link to="/contact/">contact</Link></li>
          </ul>
        </nav>
  
        <div
          className={styles.title}
        >
          <h1 className={styles.siteTitle}>
            {siteTitle}
          </h1>
        </div>
  
        <div
          className={styles.bottomRow}
        >
          <img 
            className={styles.chrisSprite}
            src={chrisSprite} 
            alt=""
          />
          <div className={styles.grassBackground}
            style={{
              backgroundImage: `url(${grass})`,
            }}
          >
          </div>
  
          <div className={styles.sandBackground}
            style={{
              backgroundImage: `url(${sand})`,
            }}
          >
          </div>
        </div>
      </div>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/header.js